
    /// <summary>
    /// AB相关业务入口API

    import KitAPI from "../KitAPI";
    import KitLog from "../KitLog";
    import { KitTrack } from "../Track/KitTrack";
    import { KitEvent } from "../Track/KitEvent";
    import { AbCacher } from "./ABCacher";
    import { ABRequest } from "./ABRequest";
    import { ABAllowGameChecker } from "./ABEnterChecker";
    import {KitAdjust} from "@/Fwk/Kit/Adjust/KitAdjust";
    import {JObject} from "@/Fwk/Kit/JObject";
    import {EventName} from "@/Fwk/Kit/Track/TrackConst";
    import {NetworkMonitor} from "@/Fwk/Kit/NetworkMonitor";
    import {ABConst} from "@/Fwk/Kit/AB/ABConst";

    /// </summary>
    export default class KitAB
    {
        private static _hasInit: boolean = false;
        private static  LOG_TAG = "[AB]";
        public static hadGotData:boolean = false;
        private static startTime: number;
        public static _isSilent: boolean = false;
        private static listeners: Array<() => void> = [];

        public static Init(isSilent: boolean)
        {
            this._isSilent = isSilent;
            //初始化逻辑
            //读取旧的AB缓存存档
            if (KitLog.IsLog) this.Log("初始化AB");
            this.startTime = new Date().getTime();
            AbCacher.Init();
            ABRequest.Init();
            this._hasInit = true;
            ABRequest.Requst();
            NetworkMonitor.registerListener((open:boolean)=>{this.OnNetwork(open)});
        }

        static Log(msg: string) {
            KitLog.Log(this.LOG_TAG, msg);
        }

        static LogWarning(msg: string) {
            KitLog.LogWarning(this.LOG_TAG, msg);
        }

         static AddDataListener( action:()=>void)
        {
            if (!this.listeners.concat(action)) this.listeners.push(action);
        }

        static RemoveDataListener(action:()=>void) {
            const index = this.listeners.indexOf(action);
            if (index !== -1) {
                this.listeners.splice(index, 1);
            }
        }

         static NotifyConfigSuc()
        {
            if (KitLog.IsLog) this.Log("通知运营配置改变");
            this.listeners.forEach((listener) => listener?.());
        }

        private static OnNetwork( isNetWorkOk:boolean)
        {
            if (!isNetWorkOk) return;
            if (KitLog.IsLog)this.Log("网络状态从无网切换到有网，开始判断是否屏蔽游戏币/玩赚功能");
            if (this.hadGotData) return;
            if (KitLog.IsLog)this.Log("网络状态从无网络到有网络，本地缓存有效，但本次app启动还没有获取到过运营配置，开始抓取配置");
            ABRequest.Requst();
        }

        public static AttributionChanged()
        {
            if (KitLog.IsLog) this.Log("归因信息变化");
            if (!this._hasInit) return;
            KitTrack.TrackALive(EventName.ALIVE);
            //重新请求
            ABRequest.Requst();
        }

        public static ForceRequst(){
            ABRequest.ForceRequst();
        }

        public static getAbExperimentData():JObject[] | null
        {
            return AbCacher.GetEntity()?.abExperimentData ?? null;
        }

        public static  getAbGroupID():string
        {
            return AbCacher.GetEntity()?.ab_group_id ?? "";
        }

        public static getBooleanConfig(key: string):boolean {
            this.checkDataTimeOver();
            let v1  = AbCacher.GetEntity()?.getDataString(key) ?? "";
            return v1 === "1";
        }

        public static getIntConfig(key: string): number {
            this.checkDataTimeOver();
            const value = AbCacher.GetEntity()?.getDataString(key) ?? "";

            if (!value)
            {
                return -1;
            }

            const i = parseFloat(value);

            if (!isNaN(i)) {
                return i
            }

            return -1;
        }

        public static getFloatConfig(key: string): number {
            this.checkDataTimeOver();
            const value = AbCacher.GetEntity()?.getDataString(key) ?? "";
            if (value) {
                return -1
            }

            const f = parseFloat(value);

            if (!isNaN(f)) {
                return f
            }

            return -1
        }

        public static getStringConfig(key:string):string
        {
            this.checkDataTimeOver();
            return AbCacher.GetEntity()?.getDataString(key) ?? "";
        }


        public static getAllConfig():string
        {
            this.checkDataTimeOver();
            return AbCacher.GetEntity()?.variables ?? "";
        }

        private static checkDataTimeOver(): void {
            var isOver = Math.abs(KitAPI.GetNowMills() - AbCacher.lastLocalGotDataTime) > 2 * 60 * 60 * 1000; //2小时有效期
            if (isOver)
            {
                if (KitLog.IsLog)this.Log("本地配置已过期，开始请求服务器运营配置");
                ABRequest.Requst();
            }
        }

        public static get curCountry() :string{
            return AbCacher.GetEntity()?.country ?? "";
        }

        public static hadGotTime(): boolean {
            return AbCacher.GetEntity()?.timestamp > 0;
        }

        public static curTime():number
        {
            var lastGotDataTime = AbCacher.lastGotDataTime;
            var elapsedRealtime = KitAPI.ElapsedRealtime();
            if (lastGotDataTime == -1)
            {
                return KitAPI.GetNowMills();
            }

            return lastGotDataTime + (elapsedRealtime - elapsedRealtime);
        }


        public static IsLoadingFinished(): boolean {
            if (!KitAPI.IsNetworkOk())
            {
                if (KitLog.IsLog)this.Log("无网络，可以跳过启动屏");
                this.TrackEnter();
                return true;
            }

            const funcstatus = ABConst.FUNC_STATUS;
            const funStatus = this.getBooleanConfig(funcstatus);
            var isBuyUserFlag = KitAdjust.IsBuyUserFlag();
            if (funStatus && isBuyUserFlag)
            {
                if (KitLog.IsLog)this.Log("func_status下发打开&&渠道归因判断为买量用户，可以跳过启动屏");
                this.TrackEnter();
                return true;
            }

            return false;
        }

        private static TrackEnter()
        {
            const consumeTime = this.GetStartInterval();
            KitEvent.track512(ABConst.STARUP_ENTER)
                .Put2(consumeTime)
                .Put(ABConst.CONSUME_TIME, consumeTime)
                .Commit();
        }

        static enterHomePage() {
            ABAllowGameChecker.enterHomePage();
        }

        static allowGameFun(): boolean {
            return ABAllowGameChecker.AllowGame();
        }

        /// <summary>
        /// app启动到现在的时间间隔
        /// </summary>
        /// <returns></returns>
        static GetStartInterval(): number {
            const time = new Date().getTime() - this.startTime;
            return Math.min(Math.abs(time), 60 * 60 * 1000);
        }
    }